/**
 * @desc 库存匹配
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(body: defs.stock.StockMatchingQry, options?: any) {
  return updateResponse(
    http(URL + `/rpc/stock/stockMatching`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
